import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	otherRecentBoards: {
		defaultMessage: 'Other boards',
		id: 'navigation-apps.switcher.other-recent-boards',
		description: 'Sidebar - Board switcher - header of the second section in board switcher',
	},
});
